import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SzCardVariant } from './sz-card.types';

@Component({
  selector: 'sz-card',
  templateUrl: './sz-card.component.html',
  styleUrls: ['./sz-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzCardComponent {
  readonly variant: InputSignal<SzCardVariant> = input<SzCardVariant>('flat');
}
